import { Component, Inject, Injector } from '@angular/core';
import { WidgetSettingsToken } from '@common-modules/dynamic-layout/dynamic-layout-external-settings';
import { GetValueSelector } from '@common-modules/dynamic-layout/state/generic/generic.selectors';
import { BaseDynamicWidgetComponent } from '@common-modules/redux/components/base-dynamic-widget.component';
import { StateWidgetSettings } from '@common-modules/redux/models/state-widget-settings';
import { ReduxStateService } from '@common-modules/redux/redux-state.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MasterOperatorGroupSettings } from '../master-operator-group/master-operator-group-settings';
import { MasterOperatorSingleSettings } from '../master-operator-single/master-operator-single-settings';
import { MasterOperatorFields } from '../models/master-operator-fields.enum';

const COMPONENT_SELECTOR = 'tc-master-operator-group-widget';

@UntilDestroy()
@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './master-operator-group-widget.component.html',
    styleUrls: ['./master-operator-group-widget.component.scss'],
    providers: [ReduxStateService],
    standalone: false
})
export class MasterOperatorGroupWidgetComponent extends BaseDynamicWidgetComponent {
  widgetInstanceKey: string;
  settings: MasterOperatorGroupSettings;
  connectItemsSettings: MasterOperatorSingleSettings;

  private _addNewOperator$ = new Subject<MasterOperatorSingleSettings>();
  readonly addNewOperator$ = this._addNewOperator$.asObservable();

  constructor(
    injector: Injector,
    @Inject(WidgetSettingsToken) widgetSettings: StateWidgetSettings
  ) {
    super(injector, widgetSettings);
    this.widgetInstanceKey = widgetSettings.widgetInstanceKey;
    this.settings = widgetSettings.params;
  }

  onWidgetInit(): void {
    //TODO: subscribe to redux action to create new operator
    this._state
      .select<MasterOperatorSingleSettings>(
        new GetValueSelector({
          fieldName: MasterOperatorFields.OperatorConnectSettings,
        })
      )
      .pipe(
        untilDestroyed(this),
        filter((data) => {
          return !!data && data.groupId == this.itemSettings.params.groupId;
        })
      )
      .subscribe((value: MasterOperatorSingleSettings) => {
        this.connectItemsSettings = value;
        if (value) {
          this._addNewOperator$.next(value);
        }
      });
  }

  get componentName(): string {
    return 'MasterOperatorGroupWidgetComponent';
  }
}
